<template>
  <div class="modal auction-conditions-modal" :class="{ 'is-active': open }">
    <div class="modal-background" @click="$emit('close')" />
    <div class="modal-content">
      <div class="modal-header">
        <button class="delete" @click="$emit('close')" />
      </div>
      <div class="modal-body">
        <div class="content">
          <div class="columns">
            <div class="column">
              <div class="has-text-centered">
                <LocalShippingIcon />
              </div>
              <span class="title">{{ shipping }} </span>
              <p class="description pre-wrap">
                {{ shippingExplanation }}
              </p>
              <ShippingViabilityChecker
                v-if="isFree && viabilityUrl"
                :viability-url="viabilityUrl"
                :states="states"
                :initial-cep="initialCep"
                page="Event"
                :mixpanel-data="mixpanelData"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LocalShippingIcon from "icons/cached/local_shipping.svg";
import ShippingViabilityChecker from "../batch/ShippingViabilityChecker.vue";

export default {
  components: {
    LocalShippingIcon,
    ShippingViabilityChecker,
  },
  props: {
    open: Boolean,
    shipping: String,
    shippingExplanation: String,
    isFree: Boolean,
    viabilityUrl: { type: String, default: "" },
    states: { type: Object, default: () => ({}) },
    initialCep: { type: String, default: "" },
    mixpanelData: { type: Object, default: () => ({}) },
  },
  emits: ["close"],
};
</script>
